import { CollectionLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"

export const TransferFlowReviewItemFragment = graphql(
  `
    fragment TransferFlowReviewItem on Item {
      id
      name
      tokenId
      imageUrl
      collection {
        ...CollectionLockup
      }
    }
  `,
  [CollectionLockupFragment],
)
